import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./caSPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"
import { drawGrandTotal } from "./caSdrawGrandTotalpdf";
export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);

  let firstPage = true;



  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



  drawGrandTotal(doc, grandTotal);


  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.DIVISIONTYPE ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          actual_L: 0,
          dist_L: 0,
          ou_LL: 0,
          actual_S: 0,
          dist_S: 0,
          ou_SS: 0,

        },
      };
    }

    const actual_L = Number(row["ACTUAL ON COST LABOUR"] || 0);
    const dist_L = Number(row["DISTRIBUTED ON COST LABOUR"] || 0);
    const ou_LL = actual_L - dist_L;

    const actual_S = Number(row["ACTUAL ON COST STORE"] || 0);
    const dist_S = Number(row["DISTRIBUTED ON COST STORE"] || 0);
    const ou_SS = actual_S - dist_S;



    groups[shop].rows.push(row);

    groups[shop].total.actual_L += actual_L;
    groups[shop].total.dist_L += dist_L;
    groups[shop].total.ou_LL += ou_LL;
    groups[shop].total.actual_ou_SSS += actual_S;
    groups[shop].total.dist_S += dist_S;
    groups[shop].total.ou_SS += ou_SS;


    return groups;
  }, {});
}